<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M49.5747 10.6053L19.4411 41.5139C19.161 41.8083 18.7754 41.9824 18.3671 41.9987C17.9588 42.0152 17.5602 41.8725 17.2569 41.6014L0.533357 26.0704C0.377465 25.9355 0.250269 25.7712 0.159166 25.5871C0.0680636 25.403 0.0148734 25.2028 0.00270088 24.9983C-0.00947539 24.7937 0.0196021 24.5887 0.0882422 24.3953C0.156882 24.2019 0.263716 24.024 0.402519 23.8718C0.541322 23.7197 0.709333 23.5964 0.896758 23.5091C1.08418 23.4218 1.28728 23.3723 1.49421 23.3634C1.70117 23.3546 1.90783 23.3865 2.1022 23.4574C2.29656 23.5283 2.47472 23.6367 2.6263 23.7764L18.2141 38.2936L47.3 8.48652C47.4406 8.33867 47.609 8.21967 47.7961 8.13632C47.9832 8.05296 48.185 8.00688 48.3901 8.00071C48.5952 7.99454 48.7996 8.0284 48.9912 8.10035C49.1832 8.1723 49.3591 8.28094 49.5084 8.42006C49.6576 8.55919 49.778 8.72607 49.8624 8.91118C49.9464 9.0963 49.9933 9.29599 49.9993 9.49892C50.0056 9.70184 49.9715 9.90399 49.8987 10.0938C49.826 10.2836 49.7154 10.4574 49.5747 10.6053Z"
      fill="#00AA73"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCheck.vue',
};
</script>
